import React, { useState, createContext, useContext } from "react";
import {
  getAllOrganization,
  getOrgUser,
  getSingleOrg,
} from "../../modules/OrgProf/hook/Organizationhook";
import { useAuth } from "../../hooks";
// import { getSingleUser } from "../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";

export const OrganizationContext = createContext();
export const useOrganizationContext = () => useContext(OrganizationContext);

export const OrganizationProvider = ({ children }) => {
  const { currentUser, organizationId } = useAuth();
  const [currentOrganization, setCurrentOrganization] = useState({});
  const [allOrganization, setAllOrganization] = useState([]);
  const [loading, setLoading] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  // useEffect(() => {
  //   handleGetOrganization();
  //   handleGetAllOrganizations();
  // }, [currentUser]);

  // useEffect(() => {
  //   handleGetOrganization();
  // }, []);

  const handleGetAllOrganizations = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getAllOrganization();
      const organizationPromises = querySnapshot.docs.map(async (item) => {
        const userData = await getOrgUser(item.id); // Retrieve user data
        return {
          ...item.data(),
          id: item.id,
          userData: userData,
        };
      });

      const temp = await Promise.all(organizationPromises);
      setAllOrganization(temp);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleGetOrganization = async () => {
    try {
      setLoading(true);
      let temp = await getSingleOrg(
        organizationId ? organizationId : currentUser.organization
      );
      const data = temp.data();
      console.log("org. data::", data);
      setCurrentOrganization({
        ...data,
        id: temp.id,
        allowAR: data.allowAR ?? false,
        autoApproveAR: data.autoApproveAR ?? false,
        importBatchAutoApprove: data.importBatchAutoApprove ?? false,
        quickCollectAutoApprove: data.quickCollectAutoApprove ?? false,
        createAreaStatusDefault:
          data.createAreaStatusDefault === "Inactive" ? "Inactive" : "Active",
      });
    } catch (error) {
      console.log("error getting org.:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGetAllOrg = async () => {
    try {
      let temp = [];
      const querySnapshot = await getAllOrganization();
      querySnapshot.docs.forEach(async (item) => {
        // const orgPro = item.data().organizations;
        // const orgProData = [];
        // console.log("orgPro", orgPro);
        temp.push({
          ...item.data(),
          id: item.id,
          orgProData: item?.data().organizations,
          // orgProData: orgProData,
        });
      });
      setAllOrganization(temp);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false);
    }
  };

  return (
    <OrganizationContext.Provider
      value={{
        currentOrganization,
        handleGetAllOrganizations,
        setCurrentOrganization,
        handleGetOrganization,
        getAllOrganization,
        allOrganization,
        setAllOrganization,
        loading,
        setLoading,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </OrganizationContext.Provider>
  );
};
